import * as React from "react";
export function SvgDataCatalogLineageLens(
  props: React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg width={24} height={24} fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 5a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-6.625L8 20v-5H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h14zm0 1H5v8h4v3.338L11.921 14H19V6zm-5 2v5h-1V8h1zm-2-1v6h-1V7h1zm-2 2v4H9V9h1z"
        fill="#666"
      />
    </svg>
  );
}
